import * as angular from 'angular';
import { fn } from '@common/utils';
import { IDialogState, DialogService } from '@services/dialogservice';

/** Description of the Concrete LoginOperation */
export type LoginOperation<TLoginResult> = (info: { Username: string, Password: string }) => PromiseLike<TLoginResult>;

/** Show Modal Login Window */
export function ShowModalLogin<TLoginResult>(operation: LoginOperation<TLoginResult>,
        context: string | JQuery | HTMLElement | DialogService) {
    var dlg: IDialogState;
    let result: TLoginResult;
    const dialogService = context instanceof DialogService ? context :
            angular.element(context).injector().get<DialogService>("DialogService");
    return dialogService.ShowWindow({
        windowOptions: {
            appendTo: context instanceof DialogService ? undefined : context,
            modal: true,
            actions: [],
            title: "Benutzeranmeldung"
        },
        controller: LoginController,
        controllerAs: "vm",
        template: require("./login.html"),
        resolve: {
            "LoginOperation": [() => operation],
            "Resolve": [() => (loginResult: TLoginResult) => {
                result = loginResult;
                dlg.window.close();
            }]
        }
    }).then(_dlg => (dlg = _dlg).close.then(() => {
        if (!result) {
            throw fn.error.ThrowCancel();
        }
        return result;
    }));
}

/** Logon Controller */
export class LoginController<TLoginResult = any> {
    static Template = require('./login.html');
    static $inject = ["$q", "LoginOperation", "Resolve"];
    constructor(
        readonly $q: ng.IQService,
        readonly _LoginOperation: LoginOperation<TLoginResult>,
        readonly _resolve: (result: TLoginResult) => void
    ) {

    }

    Username = "";
    Password = "";
    InProgress = false;
    Error = "";

    Ok() {
        if (this.Password && this.Username) {
            return this.TryLogin();
        }
    };

    TryLogin() {
        if (this.InProgress)
            return this.$q.reject('LoginOperation already in Progress');

        this.InProgress = true;
        this.Error = "";

        return this._LoginOperation({ Password: this.Password, Username: this.Username }).then((loginResult) => {
            this._resolve(loginResult);
            this.InProgress = false;
            return loginResult;
        }, err => {
            this.InProgress = false;
            this.Error = fn.resolveToError(err);
            this.Password = "";
            throw err;
        });
    }
}
